import React from "react";

import UnlockStageTwoModal from "./StageTwo/UnlockStageTwoModal";
import UnlockStageThreeModal from "./StageThree/UnlockStageThreeModal";

import UnlockStageOneModal from "@/screens/Explore/Components/UnlockFlow/StageOne/UnlockStageOneModal";
import { UserUnlockingStage } from "@/schemas/user/identity";
import { AppUserSession } from "@/schemas/auth/session";
import { UserProfile } from "@/schemas/user/profile";

type Props = {
  session: AppUserSession;
  userProfile: UserProfile;
  isModalVisible: boolean;
  onRequestClose: () => void;
  onRequestRefresh: () => void;
  isRefreshing: boolean;
};

function UnlockUsersModal({
  session,
  userProfile,
  isModalVisible,
  onRequestClose,
  onRequestRefresh,
  isRefreshing,
}: Props): React.JSX.Element {
  switch (session.identity.unlockingStage) {
    case UserUnlockingStage.ON_STAGE_ONE:
      return (
        <UnlockStageOneModal
          userProfile={userProfile}
          isModalVisible={isModalVisible}
          onRequestClose={onRequestClose}
          onRequestRefresh={onRequestRefresh}
          isRefreshing={isRefreshing}
        />
      );
    case UserUnlockingStage.ON_STAGE_TWO:
      return (
        <UnlockStageTwoModal
          userProfile={userProfile}
          isModalVisible={isModalVisible}
          onRequestClose={onRequestClose}
          onRequestRefresh={onRequestRefresh}
          isRefreshing={isRefreshing}
        />
      );
    case UserUnlockingStage.ON_STAGE_THREE:
      return (
        <UnlockStageThreeModal
          isModalVisible={isModalVisible}
          onRequestClose={onRequestClose}
          onRequestRefresh={onRequestRefresh}
        />
      );
    default:
      // Intentionally render no modal for stages that do not require an unlock modal
      // (for example, UserUnlockingStage.ON_STAGE_FOUR). Other unexpected
      // stages will also fall through here and show nothing.
      return <></>;
  }
}

export default UnlockUsersModal;
